import {ThreadStatus} from 'nutshell-graphql-types';

export const getStatusOptions = (
    status: ThreadStatus | null | undefined,
    canReopen: boolean,
    canArchive: boolean
) => {
    switch (status) {
        case ThreadStatus.OPEN:
            return [
                {value: 'OPEN', label: 'Open'},
                {value: 'CLOSE', label: 'Close'},
            ];
        case ThreadStatus.CLOSED: {
            const options = [{value: 'CLOSED', label: 'Closed'}];
            if (canReopen) {
                options.unshift({value: 'REOPEN', label: 'Reopen'});
            }
            if (canArchive) {
                options.push({value: 'ARCHIVE', label: 'Archive'});
            }

            return options;
        }
        case ThreadStatus.ARCHIVED:
            return [{value: 'ARCHIVED', label: 'Archived'}];
        default:
            return [];
    }
};
